import { Permiso_demolicion } from './../../../models/permiso_demolicion.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
declare var jQuery: any;
declare var $: any;

@Component({
    selector: "page-permiso_demolicion",
    templateUrl: "./permiso_demolicion.component.html",
    styleUrls: ["./permiso_demolicion.component.css"],
    providers: [FormService]
})

export class Permiso_demolicionComponent {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    public rows = [];
    public actualRow;
    public permiso_demolicion: Permiso_demolicion;
    public form;
    public temp_perm;

    public fecha_perm;

    public maxDate;

    public matcher = new FormService();

    constructor(private fb: FormBuilder, private dialog: MatDialog) {

        this.form = new FormGroup({
            perm_numero: new FormControl('', [Validators.min(0),Validators.pattern(/[0-9]*/)]),
            perm_fecha: new FormControl({ value: null }),
            solicitud: new FormControl(''),

        })
        this.maxDate = moment().toDate()

        if (!JSON.parse(localStorage.getItem("permiso_demolicion"))) {
            localStorage.setItem("permiso_demolicion", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("permiso_demolicion"));
            //console.log('permiso_demolicion this.rows',this.rows)
            //console.log('permiso_demolicion this.rows[0].perm_fecha ',this.rows[0].perm_fecha)
            //console.log('new Date(this.rows[0].perm_fecha)',new Date(this.rows[0].perm_fecha));
            this.form.controls['perm_fecha'].setValue(this.rows[0] ? new Date(this.rows[0].perm_fecha) : null),
                this.form.controls['perm_numero'].setValue(this.rows[0] ? this.rows[0].perm_numero : '')
            this.form.controls['solicitud'].setValue(this.rows[0] ? this.rows[0].solicitud : '');
            console.log('console.log(this.form.controls["perm_fecha"])', this.form.controls['perm_fecha'])
            //this.form.controls['solicitud2'].setValue(this.rows[0]?this.rows[0].solicitud2:false)
        }
        // this.permiso_demolicion = { perm_numero: '', perm_fecha: null, solicitud: 'NO' };
        // this.temp_perm = { perm_numero: '', perm_fecha: null, solicitud: 'NO' };
        // this.form.controls['perm_numero'].setValue(this.rows[0]?this.rows[0].perm_numero:'')
        // this.form.controls['perm_fecha'].setValue(this.rows[0]?new Date(this.rows[0].perm_fecha):null)


    }

    add_permiso_demolicion(event?: MatDatepickerInputEvent<Date>, type?) {

       

        if(event){

            this.fecha_perm = moment(event.value).format('DD/MM/YYYY')
       } else {
           var temp = JSON.parse(localStorage.getItem("cip"))
           if(temp[0]){
               this.fecha_perm = temp[0].fecha_perm
           }else {
               this.fecha_perm = ''
           }
           
       }

        localStorage.setItem("permiso_demolicion", JSON.stringify([]));
        this.actualRow = localStorage.getItem("permiso_demolicion");
        this.rows = JSON.parse(this.actualRow);

        this.rows = this.rows.concat({
            perm_numero: this.form.value.perm_numero,
            perm_fecha: moment(this.fecha_perm).format('DD/MM/YYYY'),
            solicitud: this.form.value.solicitud == 'SI' ? 'NO' : 'SI'

        })
        localStorage.setItem("permiso_demolicion", JSON.stringify(this.rows));
    }

    delete_permiso_demolicion(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("permiso_demolicion", JSON.stringify(this.rows));
            }
        }
    }


}